import { createContext, useContext } from "react";
import { TenantConfig } from "../types/tenant";

export interface TenantContextType {
  config: TenantConfig | null;
  isLoading: boolean;
  error: Error | null;
}

export const TenantContext = createContext<TenantContextType>({
  config: null,
  isLoading: true,
  error: null,
});

// Nullable — for provider/loading-aware code (config is null while it loads).
export const useTenant = () => useContext(TenantContext);

// Non-null — for components rendered inside OptimizedTenantProvider's loaded
// gate, where config is guaranteed present. Fails loudly if that invariant is
// ever violated instead of risking a silent null crash.
export const useRequiredTenant = (): TenantConfig => {
  const { config } = useTenant();
  if (!config) {
    throw new Error(
      "useRequiredTenant must be used inside a resolved tenant (OptimizedTenantProvider gate)"
    );
  }
  return config;
};
